import { HelpDeskTaskRequest, IssueCreationResult } from '../../../types/apiDomain';
import { post } from '../../request';

const requestHelpDeskTask = (data: HelpDeskTaskRequest): Promise<IssueCreationResult> => {
    return post<IssueCreationResult>({
        url: '/api/jira/help-desk',
        data
    });
};

export default requestHelpDeskTask;
